import React from 'react';
import cn from 'classnames';

export interface ICourseAccordionLabelProps {
	content: React.ReactNode;
	isError?: boolean;
	className?: string;
}

const CourseAccordionLabel = ({ content, isError, className }: ICourseAccordionLabelProps) => {
	return (
		<div className={cn('accordion-label', 'overlappable-item', { error: isError }, className)}>
			{content}
		</div>
	);
};

export default CourseAccordionLabel;
